import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { Elements } from 'react-stripe-elements';
import { Button, Row, Col } from 'react-bootstrap';
import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import FormErrors from 'components/forms/FormErrors';
import Loader from 'components/layout/Loader';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormInput from 'components/forms/FormInput';

class PreviewEmailForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      previewHTML: '',
      isRendering: false,
      selectedEmail: '',
      url: '/api/whitelabel/email/previewEmail.html',
    };
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { formStatus } = this.props;
    if (prevProps.formStatus.pending && !formStatus.pending) {
      if (!formStatus.hasError) {
        this.setState({ previewHTML: formStatus?.response, isRendering: false });
      } else {
        this.setState({ isRendering: false });
      }
    }
  };

  initiatePreview = () => {
    const { formStatus, getPreview } = this.props;
    const { selectedEmail, url } = this.state;
    // prepare conversion data
    if (!formStatus.pending) {
      this.setState({ isRendering: true, previewHTML: '&hellip;' });
      const data = { email: selectedEmail };
      getPreview(url, data);
    }
  };

  setEmailTemplate = (name, value) => {
    this.setState({ selectedEmail: value });
  };

  setUrl = (name, value) => {
    this.setState({ url: value });
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      formStatus,
      close,
    } = this.props;

    const { previewHTML, isRendering, selectedEmail } = this.state;

    const templateOptions = [
      'Default:registration',
      'Default:chedriRegistration',
      'Default:newInvoice',
      'Default:newSalesCommission',
      'Default:newQuote',
      'Default:orderCampaignBudgetAuthRequest',
      'Default:orderCampaignBudgetAuthRequestUnsuccessful',
      'Default:orderUserBudgetAuthRequest',
      'Default:orderUserBudgetAuthRequestUnsuccessful',
      'Default:orderVATDataCheckDone',
      'Default:orderReducedVatAuthorized',
      'Default:orderReducedVatRejected',
      'Default:resendInvoice',
      'Default:LastSeenReminder',
      'Default:orderedDownloadPDF',
      'Default:orderedWebPDF',
      'Default:InvoiceDueReminderClient',
      'Default:InvoiceDueReminderOwner',
      'Default:contactFormCmsConfirm',
      'Default:contactFormCms',
      'Default:editionsContactForm',
      'Default:Authorization/ContentCheck/orderContentCheckStatus',
      'Default:Authorization/ContentCheck/orderContentCheckReminder',
      'Default:LeadAssigneeChangedToAssigned',
      'Default:LeadAssigneeChangedToUnassigned',
      'Default:passwordReset',
      'Default:passwordRenew',
      'Default:orderForeignStatus/doContactSupport',
      'Default:orderForeignStatus/inDelivery',
      'Default:orderForeignStatus/inProduction',
      'Default:orderForeignStatus/invalidPrintData',
      'Default:orderForeignStatus/missingPrintData',
      'Default:orderForeignStatus/orderCanceled',
      'Default:orderForeignStatus/paymentPending',
      'Default:contactFormEdition',
      'Default:contactFormEditionConfirm',
      'Default:invitation',
      'Default:orderItemSales',
      'Default:leadPoolNotification',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/Authorization/ContentCheck/orderContentCheckStatus',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/orderForeignStatus/inDelivery',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/orderItemSales',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/registration',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/chedriRegistration',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/newSalesCommission',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/orderCampaignBudgetAuthRequest',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/orderCampaignBudgetAuthRequestUnsuccessful',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/orderUserBudgetAuthRequest',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/orderUserBudgetAuthRequestUnsuccessful',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/LastSeenReminder',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/orderedDownloadPDF',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/orderedWebPDF',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/contactFormCmsConfirm',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/contactFormCms',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/editionsContactForm',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/Authorization/ContentCheck/orderContentCheckReminder',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/LeadAssigneeChangedToAssigned',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/LeadAssigneeChangedToUnassigned',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/passwordReset',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/passwordRenew',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/orderForeignStatus/doContactSupport',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/orderForeignStatus/inProduction',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/orderForeignStatus/invalidPrintData',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/orderForeignStatus/missingPrintData',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/orderForeignStatus/orderCanceled',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/orderForeignStatus/paymentPending',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/contactFormEdition',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/contactFormEditionConfirm',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/invitation',
      'WhiteLabel:65c0e1d407284e0ccc0b7e37/leadPoolNotification',
    ];

    const urls = ['/api/whitelabel/email/previewEmail.html'];

    return (
      <Elements locale={appIntl.locale} key={appIntl.locale}>
        <>
          <Row>
            <Col xs={4} md={6}>
              <FormAutocomplete
                onChange={(name, value) => {
                  this.setEmailTemplate(name, value);
                }}
                value={selectedEmail}
                label="Templateauswahl"
                name="email"
                options={templateOptions.map(option => {
                  return { label: option, value: option };
                })}
              />
              <FormInput
                label="Anderes Template"
                name="name"
                value={selectedEmail}
                onChange={(name, value) => {
                  this.setEmailTemplate(name, value);
                }}
              />
            </Col>
            {/*
             <Col xs={4} md={4}>
              <FormAutocomplete
                onChange={(name, value) => {
                  this.setUrl(name, value);
                }}
                value='/api/whitelabel/email/previewEmail.html'
                label=""
                name="url"
                options={urls.map(option => {
                  return { label: option, value: option };
                })}
              />
            </Col>
            */}
            <Col xs={4} md={6}>
              <Button onClick={this.initiatePreview} disabled={isRendering} style={{ marginTop: '20px' }}>
                <i className="fas fa-sync-alt" />
                {messages.mail_preview_update}
              </Button>
            </Col>
            <Col xs={4} md={6}>
             <p><span>{messages.mail_preview_hint}</span></p>
            </Col>
          </Row>
          <FormErrors formStatus={formStatus} />

          {previewHTML.length > 0 ? (
            <>
              <iframe
                style={{
                  width: '100%',
                  minHeight: '30em',
                  height: '50vh',
                  border: '1px solid #CCC',
                }}
                title="Invoice preview"
                srcDoc={previewHTML}
                name="preview"
                sandbox="allow-same-origin"
              />
              <div className="text-right m-t-50">
                <Button onClick={close} disabled={isRendering} style={{ marginTop: '20px' }}>
                  {messages.mail_preview_close}
                </Button>
              </div>
            </>
          ) : (
            formStatus?.pending && <Loader />
          )}
        </>
      </Elements>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    formStatus: state.formStatus.emailPreview,
    user: state.login.user,
    projectConfig: state.data.projectConfig,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getPreview: (url, args) => {
      formStatusDispatchHelper('emailPreview', url, args, 'post', dispatch);
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(PreviewEmailForm)
  )
);
